import React, {useEffect, useRef, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import {
    formatDateTimeToString,
    formatDateToString,
    formatLocalDate,
    parseLocalDate
} from "../../utils/utils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import PlusButton from "../../core/PlusButton";
import Cookies from "js-cookie";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import SchedulesPopup from "./SchedulesPopup";

const apiUrl = Config.apiUrl;
const PrescriptionManager = () => {
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const [indexPrescriptionMedication, setIndexPrescriptionMedication] = useState(-1);

    const newEntity = {
        id: undefined,
        code: undefined,
        patientName: '',
        nursingHome: '',
        prescriptionDate: formatLocalDate(new Date()),
        createdDate: new Date(),
        status: 'TYPED',
        prescriptionMedications: []
    };


    const newPrescriptionMedication = {
        medication: '',
        quantity: 1,
        unit: 'CP',
        value: 0,
        total: 0,
        startDate: formatLocalDate(new Date()),
        endDate: formatLocalDate(new Date(new Date().setDate(new Date().getDate() + 30))),
        validityDate: '',
        batch: '',
        schedules: [],
    };
    const [formData, setFormData] = useState(newEntity);
    const [prescriptionMedications, setPrescriptionMedications] = useState([]);

    async function makeQuery() {
        if (id) {
            try {
                const url = apiUrl + '/api/prescriptions/id=' + id;
                const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
                console.log('Response:', response);
                setFormData(response);
                setPrescriptionMedications( response.medications || []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            clearEntity();
        }
    }

    async function getCustomerById(id) {

        try {
            const url = apiUrl + '/api/customers/id=' + id;
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    useEffect(() => {
        if (formData.customer && formData.customer.highlightNote && formData.customer.note && formData.customer.note !== '') {
            alert('Observação do Cliente:\n' + formData.customer.note);
        }
    }, [formData.customer]);

    useEffect(() => {
        makeQuery();
    }, [id]);

    const [schedulesPopupPosition, setSchedulesPopupPosition] = useState({x: 0, y: 0});
    const [schedulesPopupVisible, setSchedulesPopupVisible] = useState(false);
    const [indexSchedulesItem, setIndexSchedulesItem] = useState(-1);

    const handleSchedulesButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSchedulesPopupPosition({x: e.clientX, y: e.clientY- 50}); // Ajuste a posição Y para evitar sobreposição com o botão
        setSchedulesPopupVisible(true);
    };

    const handleCloseSchedulesPopup = () => {
        setSchedulesPopupVisible(false);
    };

    const handleConfirmSchedulePrescription = (schedules) => {
        setPrescriptionMedications((prevItems) =>
            prevItems.map((item, i) =>
                i === indexSchedulesItem ? {
                    ...item,
                    schedules: schedules
                } : item
            )
        );

        setSchedulesPopupVisible(false);
    }

    async function validate() {

        // if (formData.customer === undefined || formData.customer.id === undefined) {
        //     alert(`Informe o cliente.`);
        //     return false;
        // }
        //
        // if (prescriptionMedications.length === 1) {
        //     alert(`Informe ao menos 1 item.`);
        //     return false;
        // }


        return true;
    }

    const onConfirm = async () => {
        if (await validate()) {
            await confirmPrescription();
        }
    };

    async function saveEntity() {
        const userUUID = Cookies.get('userUUID');

        const prescription = {

            id: formData.id,
            code: formData.code,
            patientName: formData.patientName,
            nursingHome: formData.nursingHome,
            createdDate: formData.createdDate,
            prescriptionDate: formData.prescriptionDate,
            medications: prescriptionMedications,
            status: formData.status,

        };
        console.log(prescription);
        const url = apiUrl + '/api/prescriptions';
        const response = await makeRequest(url, id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'Useruuid': userUUID,
        }, JSON.stringify(prescription));
        return response.id;
    }

    function clearEntity() {
        setFormData(newEntity);
        setPrescriptionMedications([]);
    }

    const confirmPrescription = async () => {
        try {
            setLoading(true);
            const rentalId = await saveEntity();
            navigate('/app/prescriptionlist');
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    async function selectCustomer(id) {
        const customer = await getCustomerById(id);
        setFormData((prevData) => {
            const newFormData = {
                ...prevData,
                customer: customer
            };

            if (prevData.customer?.id !== customer?.id) {
                newFormData.address = customer.address;
                newFormData.addressNumber = customer.addressNumber;
                newFormData.addressComplement = customer.addressComplement;
                newFormData.neighborhood = customer.neighborhood;
                newFormData.cep = customer.cep;
                newFormData.city = customer.city;
                newFormData.state = customer.state;
            }

            return newFormData;
        });
    }


    const removeItem = (index) => {
        const novaLista = [...prescriptionMedications];
        novaLista.splice(index, 1);
        setPrescriptionMedications(novaLista);
    };

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    function handleOnClickProduct(index) {
        setIndexPrescriptionMedication(index);

        setPrescriptionMedications(prevMedications => {
            let startDate = newPrescriptionMedication.startDate;
            let endDate = newPrescriptionMedication.endDate;

            if (index >= 0) {
                const previousItem = prevMedications[index];
                startDate = previousItem.startDate;
                endDate = previousItem.endDate;
            }

            const currentNewPrescriptionMedication = {
                ...newPrescriptionMedication,
                startDate,
                endDate
            };

            return [
                ...prevMedications,
                currentNewPrescriptionMedication,
            ];
        });
    }


    function handleQuantityChange(index, quantity) {
        setPrescriptionMedications((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    quantity:
                    quantity
                } : item
            )
        );

    }

    function handleItemChange(index, value, field) {
        setPrescriptionMedications((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    [field]: value
                } : item
            )
        );
    }

    function handleUnitChange(index, value) {
        setPrescriptionMedications((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    unit: value
                } : item
            )
        );
    }

    async function handleDateItemChange(index, date, field) {
        setPrescriptionMedications((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    [field]:
                    formatLocalDate(date)
                } : item
            )
        );
    }
    async function handleDateChange(date, field) {
        setFormData((prevData) => ({
            ...prevData,
            [field]:
                formatLocalDate(date)
        }));
    }


    const handleEnterKeyItem = (e, nextElementId) => {
        // if (e.key === 'Enter') {
        //     e.preventDefault();
        //     e.stopPropagation(); // impede o DatePicker de abrir o calendário
        //
        //     const nextElement = document.getElementById(nextElementId);
        //     if (nextElement) {
        //         nextElement.focus();
        //     }
        // }
    };


    return (
        <>
            {schedulesPopupVisible && (
                <SchedulesPopup
                    x={schedulesPopupPosition.x}
                    y={schedulesPopupPosition.y}
                    schedules={indexSchedulesItem >= 0 ? prescriptionMedications[indexSchedulesItem].schedules : []}
                    // onSchedulesChange={(newSchedules) => {
                    //     // atualizar seu item.schedules aqui!
                    //     const newItems = [...prescriptionMedications];
                    //     newItems[itemIndex].schedules = newSchedules;
                    //     setPrescriptionMedications(newItems);
                    // }}
                    onClose={handleCloseSchedulesPopup}
                    onConfirm={handleConfirmSchedulePrescription}
                />
            )}
            <div>

                <div
                    className="header-label">{formData.id > 0 ? 'Editar' : 'Nova'} Prescrição {formData.id > 0 && '- ' + formData.code}</div>

                <div style={{display: "flex"}}>
                    <div style={{marginTop: '5px'}}>
                        <div>Nome do Paciente</div>
                        <input
                            maxLength={100}
                            type="text"
                            style={{width: '100%'}}
                            value={formData.patientName}
                            name="patientName"
                            onChange={handleChange}
                        />
                    </div>

                    <div style={{marginLeft: '5px', marginTop: '5px'}}>
                        <div>Casa de Repouso</div>
                        <input
                            maxLength={100}
                            type="text"
                            style={{width: '100%'}}
                            value={formData.nursingHome}
                            name="nursingHome"
                            onChange={handleChange}
                        />
                    </div>
                    <div style={{marginLeft: '5px', marginTop: '5px'}}>
                        <div>Lançamento</div>
                        <input
                            disabled
                            type="text"
                            style={{width: '130px'}}
                            value={formatDateTimeToString(new Date(formData.createdDate))}
                        />
                    </div>
                    <div style={{marginLeft: '5px', marginTop: '5px'}}>
                        <div>Data da receita</div>
                        <DatePicker
                            className="datepicker"
                            selected={parseLocalDate(formData.prescriptionDate)}
                            onChange={(date) => handleDateChange(date, 'prescriptionDate')}
                            dateFormat="dd/MM/yyyy"
                            onKeyDown={handleEnterKeyItem}
                            autoComplete="off"
                        />
                    </div>

                    {formData.customer &&
                        <>
                            <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                                <div>Endereço:</div>
                                <div style={{
                                    maxWidth: '425px',
                                    height: '37.6px',
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    overflowWrap: "break-word",
                                    fontSize: '14px'
                                }}>
                                    {formData.address !== undefined && (formData.address +
                                        (formData.addressNumber !== null && formData.addressNumber > 0 ?
                                            (', ' + formData.addressNumber) : '') +
                                        (formData.addressComplement !== null && formData.addressComplement !== undefined && formData.addressComplement !== '' ? ' - ' + formData.addressComplement : '') +
                                        ' - ' + formData.neighborhood)}
                                </div>
                            </div>
                        </>
                    }
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>


                    <table style={{width: '1000px', height: '351px'}}>

                        <colgroup>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '250px'}}/>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '50px'}}/>
                            <col style={{width: '50px'}}/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Qtd.</th>
                            <th>Unidade</th>
                            <th>Medicamento</th>
                            <th>Lote</th>
                            <th>Validade</th>
                            <th>Início</th>
                            <th>Fim</th>
                            <th>Horários</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody style={{overflowY: 'auto'}}>
                        {prescriptionMedications.map((item, index) => (
                            <>
                                {item && (
                                    <tr key={index}>

                                        <>
                                            <td>
                                                <input style={{width: '50px'}} key={item.id} type="number" step="1"
                                                       placeholder=""
                                                       value={item.quantity}
                                                       onChange={(e) => handleQuantityChange(index, parseFloat(e.target.value))}
                                                       onKeyDown={handleEnterKeyItem}/>
                                            </td>
                                            <td>
                                                <select style={{width: '60px'}} value={item.unit}
                                                        onChange={(e) => handleUnitChange(index, e.target.value)}
                                                        onKeyDown={handleEnterKeyItem}>
                                                    <option key={index} value={"cp"}>
                                                        CP
                                                    </option>
                                                    <option key={index} value={"cap"}>
                                                        CAP
                                                    </option>
                                                    <option key={index} value={"uni"}>
                                                        UNI
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <input style={{width: '230px'}} key={item.id}
                                                       value={item.medication}
                                                       onChange={(e) => handleItemChange(index, e.target.value, 'medication')}
                                                       onKeyDown={handleEnterKeyItem}/>
                                            </td>
                                            <td>
                                                <input style={{width: '75px'}} key={item.id}
                                                       value={item.batch}
                                                       onChange={(e) => handleItemChange(index, e.target.value, 'batch')}
                                                       onKeyDown={handleEnterKeyItem}/>
                                            </td>
                                            <td>
                                                <input style={{width: '70px'}} key={item.id}
                                                       value={item.validityDate}
                                                       onChange={(e) => handleItemChange(index, e.target.value, 'validityDate')}
                                                       onKeyDown={handleEnterKeyItem}/>
                                            </td>

                                            <td>
                                                <DatePicker
                                                    key={item.id}
                                                    className="datepicker"
                                                    selected={parseLocalDate(item.startDate)}
                                                    onChange={(date) => handleDateItemChange(index, date, 'startDate')}
                                                    dateFormat="dd/MM/yyyy"
                                                    onKeyDown={handleEnterKeyItem}
                                                    autoComplete="off"
                                                />

                                            </td>
                                            <td>
                                                <DatePicker
                                                    key={item.id}
                                                    className="datepicker"
                                                    selected={parseLocalDate(item.endDate)}
                                                    onChange={(date) => handleDateItemChange(index, date, 'endDate')}
                                                    dateFormat="dd/MM/yyyy"
                                                    onKeyDown={handleEnterKeyItem}
                                                    autoComplete="off"
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    style={{
                                                        width: '150px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                    key={item.id}
                                                    onClick={(e) => {
                                                        setIndexSchedulesItem(index);
                                                        handleSchedulesButtonClick(e);
                                                    }}
                                                    onKeyDown={handleEnterKeyItem}
                                                >
                                                    {item.schedules.length > 0 ? item.schedules.join(' - ') : 'Horários'}
                                                </button>
                                            </td>
                                            <td>

                                                <button className="remove-button"
                                                        onClick={() => removeItem(index)}>Excluir
                                                </button>
                                            </td>
                                        </>
                                    </tr>
                                )
                                }
                            </>
                        ))}
                        <PlusButton onClick={() => handleOnClickProduct(prescriptionMedications.length - 1)}/>
                        </tbody>
                    </table>

                </div>

                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%'}}>
                    <div style={{
                        marginLeft: '5px',
                        marginTop: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>

                    </div>
                </div>


                <ActionButtonsManagerView>
                    <ConfirmButton onClick={onConfirm}/>
                </ActionButtonsManagerView>

            </div>
        </>
    );
};

export default PrescriptionManager;
